function RelativeDate(){
    return function (inputDate) {
        var date = moment(inputDate);
        return date.fromNow();
    }
}

module.exports = ngModule => {
    ngModule.filter('RelativeDate', RelativeDate);
};